import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import GPWebForgotPassword from '../../../components/gp-web-forgot-password/gp-web-forgot-password';
import './gp-web-forgot-password-page.css'
import backArrow from '../../../../media/back-arrow.svg'

export class GPWebForgotPasswordPage extends Component {
  constructor(props) {
    super(props)
  }

  onClickBack = (e) => {
    e.preventDefault();

    this.props.router.goBack();
  }

  render() {
    const { t } = this.props;
    
    return (
      <div className="page">
        {document.referrer &&
          <a href={document.referrer} className="back" onClick={this.onClickBack}>
            <img alt={t('BACK')} src={backArrow} />

            {t('BACK')}
          </a>
        }
        <GPWebForgotPassword {...this.props} />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = dispatch => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
})

export default connect(mapStateToProps, mapDispatchToProps)(
  translate()(GPWebForgotPasswordPage),
)



// WEBPACK FOOTER //
// ./src/containers/pages/gp-web-forgot-password-page/gp-web-forgot-password-page.js